import React, { PropTypes } from 'react'
import css from './style.scss'

const DEFAULT_TITLE = 'We’re Here to Support You'
const DEFAULT_MESSAGE = 'Questions? Contact your institution or reach out to NCFDD at Support@NCFDD.org.'

const SupportSection = ({ config, textColor }) => {
  const title = (config && config.support_title) || DEFAULT_TITLE
  const message = (config && config.support_message) || DEFAULT_MESSAGE
  const titleStyle = textColor ? { color: textColor } : {}

  return (
    <div className={css.supportSection}>
      <h3 className={css.supportTitle} style={titleStyle}>{title}</h3>
      <p className={css.supportMessage}>{message}</p>
    </div>
  )
}

SupportSection.propTypes = {
  config: PropTypes.shape({
    support_title: PropTypes.string,
    support_message: PropTypes.string
  }),
  textColor: PropTypes.string
}

export default SupportSection
